module.exports = {
  common: {
    save: 'Save',
    cancel: 'cancel',
    combinationTitle: 'Automatic release rules (combination)',
    ruleTitle: 'Rules for automatic release',
    AutomaticOrderReleaseTriggerSettings: 'Automatic order release trigger settings',
    ReleaseGuaranteeSetting: '伝票保証書の設置です',
    docType: 'Bill of lading type',
    customerSelfRelease: 'HBL type',
    releaseType: 'Bill of lading method',
    cargoSource: 'Source of goods collection',
    creditObject: 'Release information control object',
    receivableType: 'Revenue expense type',
    creditLimitedDate: 'Credit control accounting period',
    creditLimitAmount: 'Credit control limit',
    customerType: 'Type of entrusted unit'
  },
  selectBranch: 'Select a branch:',
  ApplyTheHeadOfficeConfiguration: 'Apply the head office configuration',
  enterRuleName: 'Please enter the rule name',
  add: 'Add',
  edit: 'Edit',
  deletes: 'Delete',
  refresh: 'Refresh',
  ruleName: 'Name of automatic release rule',
  businessTypes: 'Applicable business types',
  conversionRules: 'Relevant processing rules',
  ruleDescription: 'Description',
  orderNum: 'Serial number',
  ruleGroupName: 'Name of automatic release rule (combination)',
  ruleNames: 'Include rule names',
  performActions: 'Include execution actions',
  officeCode: 'Branch',
  customerCompany: 'Applicable to customers',
  refreshSuccess: 'Refresh succeeded',
  operationSuccess: 'Operation succeeded',
  dialogRuleName: 'Rule (combination) name',
  RuleNamePlaceholder: 'Please enter the rule name',
  ruleDescriptionPlaceholder: 'Description',
  AnyRuleTitle: 'Any of the following rules apply',
  AllRuleTitle: 'All the following rules apply',
  PerformRelatedActions: 'Perform related actions',
  meetConditions: 'satisfy',
  meetConditionsRemind: 'Automatic release. (The status is updated to "Release Available") ',
  dissatisfaction: 'discontent',
  runningRules: 'Run the next rule combination',
  runningRulesRemind: 'No order.(The status is updated to "Release Available")',
  remark1: 'Remarks: when "Run the next rule combination" is selected for all combinations "Not meeting the conditions", and the actual running judgment result is not meeting the conditions.',
  remark2: 'The release status will also be updated to "To Collection"',
  applicableCustomers: 'Applicable customers',
  applicableCustomersRemind1: 'Automatic release is only applicable to customers whose settlement type is "non bill settlement"',
  applicableCustomersRemind2: '(customers with existing accounting periods)',
  conditionType: 'Condition type',
  customerName: 'Customer name',
  branchOffice: 'Branch',
  successRemind: 'Saving succeeded',
  toggleReminder: 'Please confirm again whether you want to switch the applicable customers to all? This operation will clear the customer information in the list below. ',
  tips: 'Prompt',
  yes: 'Yes',
  no: 'No',
  deleteRemind: 'Please select at least one piece of data to delete!',
  ruleName1: 'Rule Name',
  meetAnyConditions: 'Any of the following conditions are met',
  meetAllConditions: 'All of the following conditions are met',
  processingRules: 'Release Processing Rules',
  releaseDemand: 'Release on demand',
  prompt: 'Please maintain the ${prompt} information before saving.',
  Tips1: 'Please complete the rule information',
  equal: 'be equal to',
  neq: 'Not equal to',
  exceed: 'exceed',
  notMore: 'Not more than',
  SC: 'Self collection',
  NC: 'Specified goods',
  creditUsedLimitAmount: 'Used quota',
  customerIssuing: 'Customer self issuing',
  issuedCompany: 'Self issued by the company',
  original: 'original',
  telexRelease: 'Telex Release',
  accountingPeriod: 'Credit Control Set Accounting Period',
  client: 'Client',
  agent: 'Designated freight agent',
  settlement: '決済対象',
  collection: 'Collection',
  maintenanceName: 'Maintenance Rule (Combination) Name',
  rule: 'rule',
  whole: 'whole',
  TriggerTheNode: 'Trigger The Node',
  ScheduledPollingTriggersAutomaticOrderVerification: 'Scheduled polling triggers automatic order verification',
  ApplyBranchOfficeSettings: 'Apply branch office settings',
  automatic: 'automatic',
  daily: 'daily',
  blacklist: 'blacklist',
  EffectiveList: 'Effective List',
  ChargeRecordState: '料金入力状態判断',
  ChargeRecordState0: '未収費用が含まれている必要があります',
  ChargeRecordState1: '支払いにかかわらず、決済対象が委託単位である費用を含む必要がある',
  ChargeRecordState2: '費用の有無にかかわらず',
  SettlementBillMode: '請求書モード',
  SettlementBillCheckCost: '他に受取人がいない場合、委託先への買掛金が入力され、その票が支払済みとみなされる',
  SettlementBillCustomer: '委託単位の受入消込の検証のみ',
  SettlementBillCustomerCheckCost: '委託先受入がない場合、委託先への買掛金が入力され、委託先が支払済みとみなされる',
  CreditObjectMode: 'しんかんせいぎょモード'
}
